import MobileDetect from 'mobile-detect';

export default function mobileInfo(userAgent) {
  const md = new MobileDetect(userAgent);

  return {
    mobile: md.mobile(),
    os: md.os(),
  };
}



// WEBPACK FOOTER //
// ./src/mobileInfo.js